import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

// JSON
import commonEN from "./en/common.json"
import commonIT from "./it/common.json"

const detection = {
    order: ["localStorage", "navigator", "htmlTag"],
    lookupLocalStorage: "i18nextLng",
    caches: ["localStorage"],
};

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        detection,
        /*
         * Ukrainian is withdrawn, and it has to go from HERE and not only from
         * the switcher.
         *
         * The detector reads `localStorage` first and `navigator` second, so
         * anyone who had already chosen UA carries `i18nextLng: "uk"`, and a
         * Ukrainian browser resolves to "uk" on a fresh profile. Leaving the
         * bundle loaded would have kept serving both of them a Ukrainian
         * interface with no UA pill left to change it. With no `uk` resource
         * the tag resolves to nothing and `fallbackLng` takes over.
         *
         * `./uk/common.json` is deliberately left on disk: withdrawing a
         * language is not the same as discarding its translation, and putting
         * it back is then an import rather than a re-translation.
         */
        resources: {
            en: {
                common: commonEN,
            },
            it: {
                common: commonIT,
            },
        },
        fallbackLng: "en",
        defaultNS: "common",
        interpolation: {
            escapeValue: false,
        },
        debug: process.env.NODE_ENV !== "production",
    });

export default i18n
